import React from 'react'
import { bool, shape, string } from 'prop-types'
import { css } from '@emotion/core'
import AAMIconActive from './images/icon_aam_active.svg'
import AAMIconInactive from './images/icon_aam_inactive.svg'
import EMHIconActive from './images/icon_emh_active.svg'
import EMHIconInactive from './images/icon_emh_inactive.svg'
import RelativeFinderIconActive from './images/icon_relativeFinder_active.svg'
import RelativeFinderIconInactive from './images/icon_relativeFinder_inactive.svg'
import PMHIconInactive from './images/icon_pmh_inactive.svg'
import PMHIconActive from './images/icon_pmh_active.svg'
import CompareIconInactive from './images/icon_compare_inactive.svg'
import CompareIconActive from './images/icon_compare_active.svg'
import CompareCelebrityIconInactive from './images/icon_compare_celebrity_inactive.svg'
import CompareCelebrityIconActive from './images/icon_compare_celebrity_active.svg'

const icons = {
  'icon-discover': { active: AAMIconActive, inactive: AAMIconInactive },
  'icon-explore': { active: EMHIconActive, inactive: EMHIconInactive },
  'icon-relativeFinder': { active: RelativeFinderIconActive, inactive: RelativeFinderIconInactive },
  'icon-replaceFace': { active: PMHIconActive, inactive: PMHIconInactive },
  'icon-compare': { active: CompareIconActive, inactive: CompareIconInactive },
  'icon-compareCelebrity': { active: CompareCelebrityIconActive, inactive: CompareCelebrityIconInactive },
}

const imgCSS = css`
  width: 44px;
`

export default function StationMenuItem({ isAuthenticated, menuItem, isActive }) {
  return (
    <div
      tabIndex={0}
      onKeyPress={() => {
        window.location.href = menuItem.url
      }}
      onClick={() => {
        if (menuItem.ready) {
          window.location.href = isAuthenticated ? menuItem.url : menuItem.urlUnauthenticated
        }
      }}
      role="button"
      css={{
        width: '60px',
        height: '60px',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: isActive ? menuItem.color : '#FFF',
        opacity: menuItem.ready ? 1 : 0.5,
      }}
    >
      <img src={isActive ? icons[menuItem.icon].active : icons[menuItem.icon].inactive} alt="Menu Item" css={imgCSS} />
    </div>
  )
}

StationMenuItem.propTypes = {
  menuItem: shape({
    url: string,
    color: string,
    ready: bool,
  }),
  isActive: bool,
}
